import { PathRoute } from 'components/enums/path-route'

import { AppRoute } from './types'
import { Home } from '../pages/home'

export const coreRoutes: AppRoute[] = [
  { path: PathRoute.HOME, component: Home, isPrivate: true },
]
